import React, { useContext, useEffect, useCallback } from 'react'
import { VideoOverlayContext } from 'shared/components/video-inline-play/video'
import { VolumeOffIcon, VolumeOnIcon } from 'shared/components/icons/video/volume'
import { VolumeOffAnimation } from 'shared/components/icons/video/volume-animation'

import styled from 'styled-components'

const Container = styled.div`
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    height: 75px;
    width: 82px;
    background: linear-gradient(225deg, hsla(0, 0%, 0%, 0.8) 0%, hsla(0, 0%, 0%, 0.04) 48%, hsla(0, 0%, 100%, 0) 100%);

    svg {
        position: absolute;
        right: 5px;
        top: 5px;
    }
`

type Props = {
    toggleMute?: () => void
    muted: boolean
    isHovered: boolean
    volumeSize?: number
}

const VolumeButton = ({ toggleMute = () => {}, muted, isHovered, volumeSize = 38 }: Props) => {
    const { onFinishVolumeIconAnimation, finishVolumeIconAnimation } = useContext(VideoOverlayContext)

    const VolumeOffCallback = useCallback(() => {
        return !finishVolumeIconAnimation && isHovered ? (
            <VolumeOffAnimation size={volumeSize} />
        ) : (
            <VolumeOffIcon size={volumeSize} />
        )
    }, [])

    useEffect(() => {
        if (isHovered && !finishVolumeIconAnimation) {
            onFinishVolumeIconAnimation?.()
        }
    }, [isHovered])

    return (
        <Container>
            <div
                onClick={e => {
                    e.preventDefault()
                    e.stopPropagation()
                    toggleMute()
                }}
            >
                {muted ? <VolumeOffCallback /> : <VolumeOnIcon size={volumeSize} />}
            </div>
        </Container>
    )
}

export default VolumeButton
